import {consola as l} from "consola/basic";
import fcId from "./../fcId"
import uuidGenerator from "./../uuidGenerator"


export default function (url) {
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("script");

    script.type = 'text/javascript';
    script.src = url;

    script.addEventListener('load', function () {
        l.success('Load Clickio tag', url)

        document.documentElement.addEventListener(
            'clickioConsentEvent',
            function (event) {
                // event.detail.state will report the consent state
                // consentState === null consent not applicable, non-eu user
                // consentState === -1 eu user, consent interface shown, cmp loaded, user has not decided yet, waiting for user consent
                // consentState === 0 is not reported from Clickio code, may be used for different timeout fallbacks
                // consentState === 1 eu user, user consented
                // mind consentState === 1 does not mean, that user consented to everything


                try {
                    __tcfapi('addEventListener', 2, function (tcData, success) {

                        if (typeof tcData.addtlConsent !== 'undefined' && tcData.addtlConsent.length > 2) {
                            l.info('FC ID debug: choice obtained. State:', event.detail.state)

                            if (fcId.get() === null) {
                                let id = uuidGenerator()
                                fcId.set(uuidGenerator());

                                l.info('FC ID set: ', id)
                            } else {
                                l.info('FC ID already set:', fcId.get())
                            }

                        } else {
                            l.info('FC ID no consent')
                            fcId.remove();
                        }

                        if (tcData.purpose.consents) {
                            l.info('Cmp debug consents:')
                            console.table(tcData.purpose.consents);
                        }


                    });
                } catch (e) {
                    l.error('__tcfapi not defined');
                }

                l.info('Cmp consent state:', event.detail.state)

                window.sessionStorage.setItem('cmp-consent-state', event.detail.state);

                if (event.detail.state === -1) {
                    // save in localstorage interface show
                    window.localStorage.setItem('consent_interface_shown', '1');
                }

                if (event.detail.state === 1 && localStorage.getItem('consent_interface_shown') === '1') {
                    window.localStorage.removeItem('consent_interface_shown');
                    window.location.reload();
                }
            },
            false
        );
    });
    head.appendChild(script);
}